import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import { type Env, getZusApiBaseUrl } from '@ctw/shared/utils/environments';

export interface GetAuthenticatedUserArgs {
  env: Env;
  accessToken: string;
  telemetry: ReturnType<typeof useTelemetry>;
}

export interface GetAuthenticatedUserResponse {
  data: {
    type: 'auth/users';
    id: string;
    attributes: {
      authId: string;
      createdAt: number;
      email: string;
      name: string;
      updatedAt: number;
      userType: string;
    };
    relationships: Record<
      string,
      {
        data: {
          type: string;
          id: string;
        };
      }
    >;
  };
}

export const getAuthenticatedUser = async ({
  env,
  accessToken,
  telemetry,
}: GetAuthenticatedUserArgs): Promise<GetAuthenticatedUserResponse | null> => {
  try {
    const response = await fetch(new URL('/auth/users/me', getZusApiBaseUrl(env)).toString(), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    if (!response.ok) {
      telemetry.trackError({
        error: new Error(await response.text()),
        message: 'Unable to fetch currently authenticated user from auth service',
      });
      return null;
    }

    return response.json();
  } catch (error) {
    telemetry.trackError({
      error,
      message: 'Unable to fetch currently authenticated user from auth service',
    });
  }

  return null;
};
